import { z } from 'zod';
import { PROFILE_REPORT_REASONS, REPORT_REASONS } from '../constants/report.js';
/**
 * 通報する（`POST /api/v1/reports`、#256）。**選手の ID と理由だけ**を受ける。自由入力の欄は無い（`REPORT_REASONS`）。
 */
export const createReportSchema = z.object({
    characterId: z.string().min(1),
    reason: z.enum(REPORT_REASONS),
});
/**
 * ともだちと対戦の相手だった人のプロフィール（ニックネームとアバター）を通報する（`POST /api/v1/reports/profiles`、#265）。
 * **相手の利用者の ID と理由だけ**を受ける。ID は、ともだちと対戦の応答の相手の選手の `ownerId` にある。
 */
export const createProfileReportSchema = z.object({
    userId: z.string().min(1),
    reason: z.enum(PROFILE_REPORT_REASONS),
});
/**
 * 通報の応答。**件数や、ほかに通報した人がいるかは返さない**（受け付けたことだけ）。
 */
export const reportReceiptSchema = z.object({
    received: z.literal(true),
});
